export default __webpack_public_path__ + "static/media/user.124786e3.svg";